import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Copy } from "lucide-react";
import { ORG } from "@/constants/testIds";

export default function FhirViewer({ open, onClose, resource }) {
  const json = resource ? JSON.stringify(resource, null, 2) : "";
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(json);
      toast.success("FHIR JSON copied.");
    } catch {
      toast.error("Copy failed.");
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-3xl overflow-hidden" data-testid={ORG.fhirDialog}>
        <DialogHeader>
          <div className="flex items-center justify-between gap-4">
            <div>
              <DialogTitle>FHIR R4 {resource?.resourceType || "Resource"}</DialogTitle>
              <DialogDescription>Serialized resource · US Core conformant</DialogDescription>
            </div>
            <Button variant="outline" size="sm" onClick={copy} data-testid={ORG.fhirCopy}>
              <Copy className="mr-2 h-4 w-4" /> Copy
            </Button>
          </div>
        </DialogHeader>
        <pre data-testid={ORG.fhirJson}
          className="font-fhir max-h-[70vh] overflow-auto rounded-lg bg-slate-950 p-4 text-[12.5px] leading-relaxed text-teal-100">
          {json}
        </pre>
      </DialogContent>
    </Dialog>
  );
}
